// Conversion events for ad platforms.
// The Meta Pixel and GA load through Google Tag Manager (see src/pages/App.js), so every
// call here checks the global exists first and never throws if a script is blocked.

const newEventId = (name) => `${name}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`

const pushDataLayer = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event, ...params })
  } catch (e) {
    // ignore
  }
}

const metaTrack = (eventName, params = {}, eventId) => {
  try {
    if (typeof window.fbq === 'function') {
      window.fbq('track', eventName, params, eventId ? { eventID: eventId } : undefined)
    }
  } catch (e) {
    // ignore
  }
}

const gaEvent = (eventName, params = {}) => {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params)
    }
  } catch (e) {
    // ignore
  }
}

// A new Morsel account was created. `method` is 'direct' or 'invite'.
export const trackSignUp = ({ method = 'direct' } = {}) => {
  const eventId = newEventId('signup')
  metaTrack(
    'CompleteRegistration',
    { content_name: 'Morsel account', status: true, method },
    eventId
  )
  gaEvent('sign_up', { method })
  pushDataLayer('morsel_sign_up', { method, event_id: eventId })
  return eventId
}

// A paid subscription became active.
export const trackSubscribe = () => {
  const eventId = newEventId('subscribe')
  metaTrack('Subscribe', { content_name: 'Morsel subscription' }, eventId)
  gaEvent('subscribe')
  pushDataLayer('morsel_subscribe', { event_id: eventId })
  return eventId
}

// Something done in the app (started_cooking, printed_recipe, posted_activity...), for
// Google Analytics. No names or other personal details in params.
export const trackAction = (name, params = {}) => {
  gaEvent(name, params)
  pushDataLayer(`morsel_${name}`, params)
}
